import { createStore, compose } from 'redux';
import reducers from '../reducers';

function configureStore(preloadedState?: any) {
  // @ts-ignore
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(reducers, preloadedState, composeEnhancers());

  // @ts-ignore
  if (module.hot) {
    // @ts-ignore
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

const store = configureStore();

export default store;
